// export const LEADSNOW_VERSION = "V0.52-dev"
export const LEADSNOW_VERSION = "Leadsnow App"

// export const LAST_UPDATE = "10/May/2022 - 21:37 GMT+5:30"